import React, { useState } from 'react';
import './styles/formular.css';
import CTAKnap, { CTAIkoner } from '../../../components/ctaknap';

const Formular = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  // Validér formular felter
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Navn er påkrævet';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email er påkrævet';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email er ugyldig';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Besked er påkrævet';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Beskeden skal være mindst 10 tegn';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Håndter formular input ændringer
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Håndter formular submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Forbered data til webhook
      const webhookData = {
        // Kontakt information
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company,
        message: formData.message,
        
        // Metadata
        timestamp: new Date().toISOString(),
        source: 'kontakt-formular'
      };

      console.log('Sending data to webhook:', webhookData);

      // Send data til webhook
      const response = await fetch('https://n8n.srv886246.hstgr.cloud/webhook/d9b89c36-8071-44dc-b1e9-fca55d7773f1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(webhookData)
      });

      console.log('Webhook response status:', response.status);
      console.log('Webhook response headers:', response.headers);

      // Tjek om response er OK eller acceptabel
      if (response.status >= 200 && response.status < 300) {
        console.log('Webhook succeeded with status:', response.status);
        setIsSubmitted(true);
      } else {
        // Prøv at læse error response
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
          const errorData = await response.text();
          console.log('Error response:', errorData);
          errorMessage += ` - ${errorData}`;
        } catch (e) {
          console.log('Could not read error response');
        }
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrors({
        submit: 'Der opstod en fejl ved afsendelse. Prøv venligst igen.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="formular-success">
        <div className="formular-success-content">
          <div className="formular-success-icon">
            <CTAIkoner.Check />
          </div>
          <h3>Tak for din besked!</h3>
          <p>Vi har modtaget din henvendelse og kontakter dig inden for 24 timer.</p>
          <div className="formular-success-details">
            <p><strong>Navn:</strong> {formData.name}</p>
            <p><strong>Email:</strong> {formData.email}</p>
            {formData.phone && <p><strong>Telefon:</strong> {formData.phone}</p>}
            {formData.company && <p><strong>Virksomhed:</strong> {formData.company}</p>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="formular-container">
      <form onSubmit={handleSubmit} className="formular">
        <div className="formular-row">
          <div className="formular-group">
            <label htmlFor="name">Navn *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="Dit fulde navn"
              className={errors.name ? 'error' : ''}
            />
            {errors.name && <span className="formular-error-message">{errors.name}</span>}
          </div>
          <div className="formular-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="din@email.dk"
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="formular-error-message">{errors.email}</span>}
          </div>
        </div>

        <div className="formular-row">
          <div className="formular-group">
            <label htmlFor="phone">Telefon</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="+45 12 34 56 78"
            />
          </div>
          <div className="formular-group">
            <label htmlFor="company">Virksomhed</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleInputChange}
              placeholder="Din virksomhed"
            />
          </div>
        </div>

        <div className="formular-group">
          <label htmlFor="message">Ekstra info *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            required
            rows="5"
            placeholder="Fortæl os hvad du har brug for hjælp til..."
            className={errors.message ? 'error' : ''}
          />
          {errors.message && <span className="formular-error-message">{errors.message}</span>}
        </div>

        {errors.submit && (
          <div className="formular-error-general">
            {errors.submit}
          </div>
        )}

        <div className="formular-submit">
          <CTAKnap
            type="submit"
            variant="primary"
            size="large"
            loading={isSubmitting}
            disabled={isSubmitting}
            icon={<CTAIkoner.ArrowRight />}
          >
            {isSubmitting ? 'Sender besked...' : 'Send besked'}
          </CTAKnap>
          <p className="formular-note">
            Vi svarer på alle henvendelser inden for 24 timer
          </p>
        </div>
      </form>
    </div>
  );
};

export default Formular;
